<template>
  <generic-modal
    size
    :title="$t('datasource')"
    icon="chart bar"
    image="/images/icons/data_source.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="setup.name" />
        </div>
        <div class="field">
          <label for>{{ $t("description") }}</label>
          <textarea name="description" rows="2" v-model="setup.description"></textarea>
        </div>
        <div class="ui basic mini right floated icon labeled button" @click="add_field">
          <i class="green plus icon"></i>
          {{$t("add field")}}
        </div>
        <h4 class="ui dividing header">{{$t("fields")}}</h4>
        <div class="three fields" v-for="(field, index) in setup.fields" :key="index">
          <div class="seven column wide field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="setup.fields[index].name" />
          </div>
          <div class="seven column wide field">
            <label for>{{ $t("type") }}</label>
            <select
              class="ui dropdown"
              name="type"
              v-model="setup.fields[index].type"
              ref="type_dropdown"
            >
              <option value="varchar">{{$t("varchar")}}</option>
              <option value="numeric">{{$t("numeric")}}</option>
              <option value="date">{{$t("date")}}</option>
            </select>
          </div>
          <div class="two column wide field">
            <label for>{{$t("options")}}</label>
            <div class="ui red icon button" @click="remove(index)">
              <i class="trash icon"></i>
            </div>
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "DataSourceModal",
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { datasource: Object },
  data() {
    return {
      uuid: undefined,
      setup: {
        name: "",
        description: "",
        fields: []
      },
      form: undefined
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          let req = vm.setup;
          req.u = vm.uuid;
          local_api(vm, "post", "/ngine_core/datasource/do-save", req)
            .then(datasource => {
              vm.$emit("succedded", datasource);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
    },
    add_field() {
      this.setup.fields.push({ name: this.$t("new_field"), type: "varchar" });
      setTimeout(() => {
        window.jQuery(this.$refs.type_dropdown).dropdown();
      }, 100);
    },
    remove(index) {
      this.setup.fields.splice(index, 1);
    }
  },
  mounted() {
    let vm = this;

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"]
      }
    });

    if (vm.datasource) {
      vm.form.form("set values", {
        name: vm.datasource.name,
        description: vm.datasource.description
      });
      vm.setup.name = vm.datasource.name;
      vm.setup.description = vm.datasource.description;
      vm.setup.fields = vm.datasource.setup.fields;
      vm.uuid = vm.datasource.uuid;
    }
  },
  watch: {},
  updated: function() {}
};
</script>
